import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider, FieldArray, getIn } from 'formik';
import { connect } from "react-redux";
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import { DropzoneArea } from "material-ui-dropzone";
// material
import {
    Link,
    Card,
    Stack,
    Checkbox,
    TextField,
    IconButton,
    InputAdornment,
    FormControlLabel,
    Container,
    Typography,
    TableContainer,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TablePagination,
    Grid,
    Button,
    TextareaAutosize
} from '@mui/material';
import { ListHead, ListToolbar, MoreMenu } from '../../components/_dashboard/car';
import { LoadingButton } from '@mui/lab';
import Scrollbar from '../../components/Scrollbar';
import { updateAgreementInfo } from '../../actions/agreementAction';
import _ from 'lodash';
import Page from '../../components/Page';
import { styled } from '@mui/material/styles';
import Edit from "@material-ui/icons/Edit";
import DeleteOutlined from "@material-ui/icons/DeleteOutlined";
import ModalCompoennt from '../Portal/ModalCompoennt';


// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
    maxWidth: 680,
    margin: 'auto',
    minHeight: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
}));

const TABLE_HEAD = [
    { id: 'id', label: 'ID', alignRight: false },
    { id: 'name', label: 'Name', alignRight: false },
    { id: 'email', label: 'Email', alignRight: false },
    { id: 'action', label: 'Actions', alignRight: false },
];


function UpdateAgreement(props) {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [adminObj, setAdminObj] = useState({});
    const [openUpdate, setOpenUpdate] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [files, setFiles] = useState([]);
    
    const AddSchema = Yup.object().shape({
        description: Yup.string().required('Description is required'),
        notes: Yup.array().of(
            Yup.object().shape({
                note : Yup.string().required("Note is required"),
            })
        )
    });

    const formik = useFormik({
        initialValues: {
            agreement_id: props.agreement.id,
            description:props.agreement.description,
            notes: props.agreement.notes.map((note) =>  {return{id:Math.random(),note:note.note}})
        },
    validationSchema: AddSchema,
        onSubmit: (values, {resetForm}) => {
            resetForm();
            setIsLoading(true);
            const fd = new FormData();
            fd.append('description',values.description);
            fd.append('car_detail_id',props.carObj.carObj.id);
            fd.append('notes', JSON.stringify(values.notes));
            files.forEach(file => {
                fd.append('files[]', file, file.name);
            });
            props.updateAgreementInfo(fd);
        }
    });

    const handleFileChange = (files) => {
        setFiles(files);
    }

    useEffect(() => {
        setIsLoading(false);
        if(props.alerts.status == 'success') {
            props.onDismis();
        }
    }, [props.alerts]);

    const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, handleChange, handleBlur } = formik;

    return (
        <Page title="UpdateAgreement">
            <Container maxWidth="lg">
                <Card sx={{padding:"1em"}}>
                    <Stack sx={{ mb: 5 }}>
                        <Typography variant="h5" gutterBottom>
                            Agreement
                        </Typography>
                        <Typography sx={{ color: 'text.secondary' }} gutterBottom>Car Details</Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <b>Car Name:</b> {!_.isEmpty(props.agreement) && props.agreement.car.motor}
                            </Grid>
                            <Grid item xs={6}>
                                <b>Chasis No:</b> {!_.isEmpty(props.agreement) && props.agreement.car.chasis_no}
                            </Grid>
                            <Grid item xs={6}>
                                <b>Engine No:</b> {!_.isEmpty(props.agreement) && props.agreement.car.engine_no}
                            </Grid>
                            <Grid item xs={6}>
                                <b>Registration No:</b> {!_.isEmpty(props.agreement) && props.agreement.car.reg_no}
                            </Grid>
                        </Grid>
                    </Stack>
                    <FormikProvider value={formik}>
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <FieldArray name="notes">
                                {({ push, pop }) => (
                                    <div>
                                        <div style={{float:"right"}}>
                                            <Button style={{padding:"0px 4px 0px 4px", cursor:"pointer"}} variant="danger" onClick={() => {
                                                    if(values.notes.length > 1) {
                                                        pop('notes')
                                                    }
                                                }}
                                            >
                                                -
                                            </Button>
                                            <Button style={{padding:"0px 2px 0px 2px", cursor:"pointer", marginRight:"3px"}} variant="primary" onClick={() => {
                                                push({ id: Math.random(), note: "" })
                                                }}
                                            >
                                                +
                                            </Button> 
                                        </div>
                                        {values.notes.map((p, index) => {
                                            const note = `notes[${index}].note`;
                                            const touchedNote = getIn(touched, note);
                                            const errorNote = getIn(errors, note);
                                            return (
                                                <div id={p.id}>
                                                    <TextField
                                                        fullWidth
                                                        margin="normal"
                                                        variant="outlined"
                                                        label="Note on agreement"
                                                        name={note}
                                                        value={p.note}
                                                        required
                                                        helperText={
                                                            touchedNote && errorNote
                                                            ? errorNote
                                                            : ""
                                                        }
                                                        error={Boolean(touchedNote && errorNote)}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </FieldArray>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography gutterBottom>
                                        <b>Upload Attachment</b>
                                    </Typography>
                                    {/* <TextField
                                        fullWidth
                                        type="file"
                                        name="logo"
                                        onChange={onChangeHandler}
                                    /> */}
                                    <DropzoneArea 
                                        filesLimit={10} 
                                        onChange={handleFileChange} 
                                        acceptedFiles={["image/*"]}
                                        showPreviews={true}
                                        initialFiles={props.agreement.attachments.map((a) => {
                                            return `https://portal-laravel.sleektradingltd.com/${a.url}`
                                        })} 
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography gutterBottom>
                                        <b>Description</b>
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        type="text"
                                        label="Description*"
                                        {...getFieldProps('description')}
                                        error={Boolean(touched.description && errors.description)}
                                        helperText={touched.description && errors.description}
                                    />
                                </Grid>
                            </Grid>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
                            </Stack>
                            <LoadingButton
                                size="medium"
                                type="submit"
                                variant="contained"
                                loading={isLoading}
                                sx={{backgroundColor: '#c29136',float:"right"}}
                            >
                                create
                            </LoadingButton>
                        </Form>
                    </FormikProvider>
                </Card>
            </Container>
        </Page>
    );
}
const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        alerts: state.alerts,
    }
}

export default connect(mapStateToProps, { updateAgreementInfo })(UpdateAgreement);

